{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} conversations sélectionnées",
    "NONE": "Aucun",
    "CLEAR_SELECTION": "Clear",
    "ASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {agentName}? | Are you sure you want to assign {n} conversations to {agentName}?",
    "UNASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
    "YES": "Oui",
    "CANCEL": "Annuler",
    "SEARCH_INPUT_PLACEHOLDER": "Rechercher",
    "ASSIGN_AGENT_TOOLTIP": "Assigner un agent",
    "ASSIGN_TEAM_TOOLTIP": "Assigner une équipe",
    "ASSIGN_SUCCESFUL": "Conversations assignées avec succès.",
    "ASSIGN_FAILED": "Échec de l'attribution des conversations, veuillez réessayer.",
    "RESOLVE_SUCCESFUL": "Conversations résolues avec succès.",
    "RESOLVE_FAILED": "Impossible de résoudre les conversations, veuillez réessayer.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Sont uniquement sélectionnées les conversations visibles sur cette page.",
    "UPDATE": {
      "CHANGE_STATUS": "Changer le statut",
      "SNOOZE_UNTIL": "Reporter",
      "UPDATE_SUCCESFUL": "Le statut de la conversation a été mis à jour avec succès.",
      "UPDATE_FAILED": "Impossible de mettre à jour les conversations, veuillez réessayer."
    },
    "RESOLVE": {
      "ALL_MISSING_ATTRIBUTES": "Cannot resolve conversations due to missing required attributes",
      "PARTIAL_SUCCESS": "Some conversations need required attributes before resolving and were skipped"
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assigner une étiquette",
      "REMOVE_LABELS": "Remove labels",
      "ASSIGN_SELECTED_LABELS": "Assigner les étiquettes sélectionnées",
      "REMOVE_SELECTED_LABELS": "Remove selected labels",
      "ASSIGN_SUCCESFUL": "Étiquettes attribuées avec succès.",
      "ASSIGN_FAILED": "Impossible d'attribuer les étiquettes, veuillez réessayer.",
      "REMOVE_SUCCESFUL": "Labels removed successfully.",
      "REMOVE_FAILED": "Failed to remove labels. Please try again."
    },
    "TEAMS": {
      "NONE": "Aucun",
      "ASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {teamName}? | Are you sure you want to assign {n} conversations to {teamName}?",
      "UNASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Impossible d'assigner l'équipe, veuillez réessayer."
    }
  }
}
